import Bus from '@/bus/BusEvent.js'
import Store from '@/stores/store.js'

class Data {
    constructor(data) {
        this.clients = null;
        this.about = null;
        this.fetchPromise = this.fetch().then(()=>{
            this.onDataLoaded();
        });
    }

    fetch() {
        const that = this;

        return new Promise(function (resolve, reject) {
            let request = new XMLHttpRequest();
            request.open('GET', 'https://dillinger.cdn.prismic.io/api/v2', true);
            request.onload = function () {
                if (this.status >= 200 && this.status < 400) {
                    const masterRef = JSON.parse(this.response).refs[0].ref;
                    request = new XMLHttpRequest();
                    request.open('GET', `https://dillinger.cdn.prismic.io/api/v2/documents/search?ref=${masterRef}&pageSize=100`, true);
                    request.onload = function () {
                        if (this.status >= 200 && this.status < 400) {
                            that.data = JSON.parse(this.response);
                            resolve();
                        } else {
                            console.log("We reached our target server, but it returned an error");
                            reject();
                        }
                    }
    
                    request.onerror = function () {
                        console.log("error comes up when trying to fetch the data")
                        reject();
                    }
                    request.send();
                } else { 
                    console.log("We reached our target server, but it returned an error"); 
                    reject();
                }
            }

            request.onerror = function () { console.log("error comes up when trying to fetch the master ref") }
            request.send();
        });

    }

    onDataLoaded(){
        Store.state.dataLoaded = true;
    }

    getNews(){
        if (!this.news) {
            this.news = this.data.results.filter((result) => { return result.type === "news" });
        }
        return this.news;
    }

    getAbout() {
        if (!this.about) {
            this.about = this.data.results.filter((result) => { return result.type === "about" });
        }
        return this.about;
    }


    getDirectors() {
        if (!this.directors) {
            this.directors = this.data.results.filter((result) => { return result.type === "director" });
            this.shuffleArray( this.directors );
            this.directors.forEach((director)=>{
                this.shuffleArray( director.data.realisations );
            })
        }
        return this.directors;
    }

    shuffleArray(array) {
        for (var i = array.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }
    }

    nestedSort(prop, arr){
        prop = prop.split('.');
        var len = prop.length;
        arr.sort(function (a, b) {
            var i = 0;
            while (i < len) {
                a = a[prop[i]];
                b = b[prop[i]];
                i++;
            }
            if (a < b) {
                return -1;
            } else if (a > b) {
                return 1;
            } else {
                return 0;
            }
        });
        return arr;
    }

    async getNewsBySlug(slug) {
        await this.fetchPromise
        
        let result = null;

        this.getNews().forEach(item => {
            if (item.slugs.indexOf(slug) > -1) {
                result = item;
            }
        });

        return result;
    }

    async getDirectorBySlug(slug) {
        
        await this.fetchPromise

        let result = null;

        this.getDirectors().forEach(item => {
            if ( item.slugs[0] === slug ){
                result = item;
            }
        });
        return result;
    }

}
const data = new Data();
export default data;